import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import { Link } from "react-router-dom";

const Scenery_zn = () => {
  return (
    <React.Fragment>
      <SEO title="风景名胜 | ICSI 2026" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="风景名胜"
        content="For Participants"
        contentTwo="风景名胜"
        linkage="/"
      />

      <EmptyTwo>
        <div className="entry-content2">
          <div className="ch-lang-ch">
            <Link className="btn btn-primary btn-hover-secondary mt-s" to={process.env.PUBLIC_URL + "/scenery"}>
              English
            </Link>
          </div>
          <div className="space-50"></div>
          <h2>北京景点</h2>
          <p align="justify">
            <b>
              北京，中国的首都，是一座将古老历史与现代创新完美融合的城市。作为世界上人口最多的城市之一，它是中国的政治、文化和教育中心。北京以其丰富的文化遗产、标志性建筑以及传统与现代建筑风格的独特融合而闻名，从古老的寺庙和皇家宫殿到现代化的摩天大楼，应有尽有。
              <br></br>
              北京拥有一些世界上最著名的历史遗址，包括横跨中国北部的世界文化遗产——长城，以及曾经的皇家宫殿——故宫，它让人们一窥中国的皇家历史。另一个必游之地是天坛，明清两代的皇帝曾在这里举行仪式，祈求丰收。
              <br></br>
              北京的美食场景是美食爱好者的天堂，提供各种地道的中国菜肴，如北京烤鸭、饺子和火锅。无论您是在历史悠久的胡同中漫步，还是探索王府井和三里屯等繁华的购物区，北京都为所有游客提供了充满活力和难忘的体验。
            </b>
          </p>

          <ul>
            <li>
              <a href="#Peking University">北京大学</a>
            </li>
            <li>
              <a href="#The Great Wall of China">长城</a>
            </li>
            <li>
              <a href="#The Forbidden City">故宫</a>
            </li>
            <li>
              <a href="#Monument to the Peoples Heroes">人民英雄纪念碑</a>
            </li>
            <li>
              <a href="#Tiananmen Square">天安门广场</a>
            </li>
            <li>
              <a href="#The Temple of Heaven">天坛</a>
            </li>
            <li>
              <a href="#The Summer Palace">颐和园</a>
            </li>
            <li>
              <a href="#The Old Summer Palace">圆明园</a>
            </li>
            <li>
              <a href="#Yonghe Temple">雍和宫</a>
            </li>
          </ul>

          <br />

          <hr></hr>
          <h4 id="Peking University">北京大学</h4>
          <p align="justify">
            北京大学，中国最负盛名和标志性的学府之一，坐落于北京市中心。成立于1898年，它拥有超过一个世纪的悠久历史，是中国现代教育的摇篮，也是知识与文化发展的灯塔。校园内传统的中式建筑与宁静的景观交相辉映，为人们提供了一处远离城市喧嚣的静谧之地，同时也展现了中国学术传统的深厚底蕴。
          </p>
          <p>
            <img
              src="./images/beijing/beijingdaxue.jpg"
              alt="北京大学"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="The Great Wall of China">长城</h4>
          <p align="justify">
            长城是世界上最标志性的地标之一，横跨中国北部，全长超过13,000英里。它建于多个世纪，用于防御外敌入侵，提供了壮丽的景色和中国古代历史的一瞥。参观长城是每个来北京旅游的人必做的事情，它象征着中国的坚韧和建筑智慧。
          </p>
          <p>
            <img
              src="./images/beijing/changcheng.jpg"
              alt="长城"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="The Forbidden City">故宫</h4>
          <p align="justify">
            故宫位于北京市中心，曾是明清两代24位皇帝的皇宫。这座庞大的建筑群以其复杂的建筑和美丽的庭院而闻名，是联合国教科文组织世界遗产。它收藏了无数文物，深入展示了中国的皇家历史和文化。
          </p>
          <p>
            <img
              src="./images/beijing/gugong.png"
              alt="故宫"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Monument to the Peoples Heroes">人民英雄纪念碑</h4>
          <p align="justify">
            人民英雄纪念碑矗立在天安门广场，纪念为中国的革命斗争牺牲的人们。这座高耸的方尖碑是民族自豪感和坚韧的象征，周围环绕着重要的历史地标。它提醒着中国走向现代化和独立的历程。
          </p>
          <p>
            <img
              src="./images/beijing/renminyingxiong.jpg"
              alt="人民英雄纪念碑"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Tiananmen Square">天安门广场</h4>
          <p align="justify">
            天安门广场是世界上最大的公共广场之一，是北京的中心地标。它是许多重要历史事件的场所，周围环绕着人民大会堂和中国国家博物馆等重要建筑。广场是中国政治和文化身份的象征。
          </p>
          <p>
            <img
              src="./images/beijing/tiananmen.jpg"
              alt="天安门广场"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="The Temple of Heaven">天坛</h4>
          <p align="justify">
            天坛是中国宗教建筑的杰出代表，明清两代的皇帝在这里举行仪式，祈求丰收。天坛公园是一个宁静的避风港，深受当地人喜爱，适合晨练和休闲活动。其和谐的设计反映了古代中国对天地联系的信仰。
          </p>
          <p>
            <img
              src="./images/beijing/tiantan.jpg"
              alt="天坛"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="The Summer Palace">颐和园</h4>
          <p align="justify">
            颐和园是中国园林设计的杰作，由湖泊、花园和宫殿组成。它是皇帝避暑的豪华度假胜地。昆明湖和万寿山提供了宁静的景色，使其成为放松和欣赏中国传统美学的理想场所。
          </p>
          <p>
            <img
              src="./images/beijing/yiheyuan.jpg"
              alt="颐和园"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="The Old Summer Palace">圆明园</h4>
          <p align="justify">
            圆明园曾是一座宏伟的皇家园林。尽管在第二次鸦片战争期间大部分被毁，但其遗址仍然是中国昔日辉煌和外国入侵影响的深刻提醒。该遗址融合了自然美景和历史意义。
          </p>
          <p>
            <img
              src="./images/beijing/yuanmingyuan.jpg"
              alt="圆明园"
              width="100%"
            />
          </p>

          <h4 id="Yonghe Temple">雍和宫</h4>
          <p align="justify">
            雍和宫，又称喇嘛庙，是世界上最大和最重要的藏传佛教寺院之一。其令人惊叹的建筑、精美的雕刻和宁静的氛围使其成为北京喧嚣城市中的精神避风港。游客可以在这里体验藏传佛教的丰富文化遗产。
          </p>
          <p>
            <img
              src="./images/beijing/yonghegong.jpg"
              alt="雍和宫"
              width="100%"
            />
          </p>

          <br></br>
          <br></br>

          <h3>参会者出行提示</h3>
          <br></br>
          <p align="justify">
            北京首都国际机场（PEK）和北京大兴国际机场（PKX）连接着北京与全球主要城市。北京地铁网络四通八达，可便捷抵达机场、火车站、主要景点及待定的会议会场。支付宝和微信支付在市内广泛使用，多数场所也支持信用卡。北京七月气温较高（25–33°C），建议穿着轻便衣物，并备好防晒用品与舒适步行鞋。
          </p>
          <p align="justify">
            北京深厚的文化底蕴、丰富的美食体验与蓬勃的科技创新，将为 ICSI&apos;2026 参会者带来充实而难忘的旅程。
          </p>
        </div>
      </EmptyTwo>
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Scenery_zn;
